// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"QP","backgroundimage":"RP","header":"SP","headerwrap":"TP","title":"UP","promomessage":"VP","upsellItem":"WP","upsellImg":"XP","helperText":"YP","upsellHeadline":"ZP","price":"aQ","upsellGross":"bQ","upsellNet":"cQ","upsellButton":"eQ","nutritionfacts":"fQ","nutritionimg":"gQ","containerwhy":"hQ","nutritionwrappwer":"iQ","headlinewhy":"jQ","boxwhy":"kQ","textwhy":"lQ","backbutton":"mQ","drawercontainer":"nQ","logoheader":"oQ","textwrap":"pQ","timer":"qQ"};
    if(module.hot) {
      // 1711717534930
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  